module.exports = __webpack_public_path__ + "media/svg/download-c9bbfcdf.svg";